angular.module('bmsApp.directives')
	.directive('dump', function() {
		return {
			restrict: 'E',
			require: [],
			scope: {
				model: '='
			},
			replace: true,
			template: '<span ng-bind-html="model | json"></span>'
		}
});
